import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SupportInstanceRepository } from '../../Compliance/Repositories/supportInstance.repository';
import { BusyIndicatorMessageManager } from '../../Busy-Indicator';
import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom, Subject } from 'rxjs';
import { UserService } from '../../Account/user.service';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

export interface SupportInstanceRequestAccessComponentParams {
    instanceId: number;
}

@Component({
    selector: 'support-instance-request-access',
    templateUrl: './supportInstanceRequestAccess.component.html',
    styleUrls: ['./supportInstanceRequestAccess.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class SupportInstanceRequestAccessComponent implements OnInit, OnDestroy, IWeissmanModalComponent<SupportInstanceRequestAccessComponentParams, Core.SupportInstanceInfoModel> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _formBuilder: UntypedFormBuilder,
        private readonly _supportInstanceRepository: SupportInstanceRepository,
        private readonly _userService: UserService,
        private readonly _toastr: ToastrService
    ) {
    }

    params: SupportInstanceRequestAccessComponentParams;
    result: Core.SupportInstanceInfoModel;
    userName: string;
    reasonLength: number = 0;
    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();
    form: UntypedFormGroup;

    private destroy$: Subject<void> = new Subject();

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            reason: [null, [Validators.required, Validators.maxLength(500)]]
        });

        this.form.controls['reason'].valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(x => this.reasonLength = (x || '').length);

        const user = this._userService.getUser();
        this.userName = `${user.firstName} ${user.lastName}`;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    cancel(): void {
        this._bsModalRef.hide();
    }

    async save(): Promise<void> {
        const busyMsgId = 'saving';
        this.busyIndicatorMessageManager.add('Saving', busyMsgId);

        const request: Core.SupportInstanceRequestModel = {
            instanceId: this.params.instanceId,
            reason: this.form.get('reason').value
        };

        try {
            this.result = await lastValueFrom(this._supportInstanceRepository.requestAccess(request));
            this._bsModalRef.hide();

            this._toastr.success(`You now have access to ${this.result.instanceName} instance. You will need to logout and log back in to see it`);
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    onReasonChange(reason: string) {
        this.reasonLength = (reason || '').length;
    }
}
